import {
  applyValueInheritance,
  findAllFormErrors,
  setMobileNumberToFormField
} from '../../helpers/formUtils';
import II18 from '../../translate/II18';
import { useSelector } from 'react-redux';
import { selectPreparedState } from '../../../redux/selectors/preparedState';

export const useRegistrationData = (
  signatureFieldId,
  signatureFields,
  currentRecipientData
) => {
  const _registrationData = useSelector(state => state.registrationData);
  const valueInheritance = useSelector(state => state.qesValueInheritance);
  const qesFirstName = useSelector(state => state.qesFirstName);
  const qesLastName = useSelector(state => state.qesLastName);
  const recipientId = useSelector(state => state.recipientId);
  const recipientEmail = useSelector(state => state.recipientEmail);
  const recipientPhone = useSelector(state => state.recipientPhone);

  const preparedState = useSelector(selectPreparedState);

  const getFieldInheritedValue = field => {
    const inheritance = valueInheritance?.[recipientId]?.[field.id];
    return (
      inheritance &&
      applyValueInheritance(
        {
          ...field,
          valueInheritance: inheritance
        },
        preparedState.preparedFormsData,
        preparedState.preparedFormsStructures,
        true
      )
    );
  };

  //set strict userCredential or Request data or inherited Document-values
  let preparedReadonlyData = new Map();
  if (currentRecipientData?.userPhone) {
    preparedReadonlyData.set(
      'phone',
      setMobileNumberToFormField(
        signatureFields.find(f => f.id === 'phone')?.element,
        currentRecipientData?.userPhone
      )
    );
  }
  if (currentRecipientData?.userEmail) {
    preparedReadonlyData.set('email', currentRecipientData.userEmail);
  }

  if (currentRecipientData?.userName) {
    preparedReadonlyData.set('userName', currentRecipientData.userName);
  }

  if (qesFirstName) {
    preparedReadonlyData.set('firstName', qesFirstName);
  }

  if (qesLastName) {
    preparedReadonlyData.set('lastName', qesLastName);
  }

  signatureFields.forEach(field => {
    if (!preparedReadonlyData.get(field.id)) {
      const value = getFieldInheritedValue(field);
      value && preparedReadonlyData.set(field.id, value);
    }
  });

  const errors = findAllFormErrors([signatureFields], preparedReadonlyData);

  const preparedStructure = signatureFields.map((item, index) => ({
    ...item,
    label: II18.get(item.label),
    tooltip: item.tooltip ? II18.get(item.tooltip) : item.tooltip,
    elementIndex: index,
    readOnly: Boolean(preparedReadonlyData.get(item.id) && !errors.has(item.id))
  }));

  //set strict data to registration data
  const registrationData = new Map(_registrationData);
  for (let [key, value] of preparedReadonlyData) {
    if (!errors.has(key)) {
      registrationData.set(key, value);
    }
  }

  //if there is stil no e-mail or phone we can take them from normal Request root
  if (!registrationData.has('email') && recipientEmail) {
    registrationData.set('email', recipientEmail);
  }

  if (!registrationData.has('phone') && recipientPhone) {
    registrationData.set(
      'phone',
      setMobileNumberToFormField(
        signatureFields.find(f => f.id === 'phone')?.element,
        recipientPhone
      )
    );
  }

  return { preparedStructure, registrationData };
};
